import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../components/ui/Button';
import Star from '../../components/ui/Star';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <section className="w-full bg-[#f6f6f6] border-b border-[#d3d3d3]">
      <div className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative w-full">
          {/* Background Stars */}
          <div className="absolute inset-0 pointer-events-none">
            <Star
              className="absolute top-[68px] right-[84px] w-[50px] h-[50px] bg-[#e7e6e6] shadow-[0px_4px_26px_#888888ff] rounded-full"
              onClick={() => {}}
            />
            <Star
              className="absolute top-[68px] right-[450px] w-[50px] h-[50px] bg-[#e7e6e6] shadow-[0px_4px_26px_#888888ff] rounded-full"
              onClick={() => {}}
            />
            <Star
              className="absolute bottom-[84px] right-[84px] w-[50px] h-[50px] bg-[#e7e6e6] shadow-[0px_4px_26px_#888888ff] rounded-full"
              onClick={() => {}}
            />
            <Star
              className="absolute bottom-[84px] right-[450px] w-[50px] h-[50px] bg-[#e7e6e6] shadow-[0px_4px_26px_#888888ff] rounded-full"
              onClick={() => {}}
            />
          </div>

          {/* Main Content */}
          <div className="flex flex-col lg:flex-row items-center min-h-[400px] lg:min-h-[534px] py-8 lg:py-12">
            {/* Text Content */}
            <div className="w-full lg:w-1/2 flex flex-col items-start justify-center px-4 lg:px-8 py-8 lg:py-12 order-2 lg:order-1">
              <div className="flex flex-col gap-6 lg:gap-8 w-full max-w-md">
                <p className="text-sm lg:text-base font-medium text-[#333333] leading-5 lg:leading-xl">
                  {t('SUMMER')}
                </p>

                <h1 className="text-3xl sm:text-4xl lg:text-6xl font-semibold text-[#333333] leading-tight lg:leading-[72px]">
                  {t('new_coll')}
                </h1>

                {/*<p className="text-base lg:text-2xl font-medium text-[#1f1c1c] leading-6 lg:leading-[30px]">
                  We know how large objects will act, but things on a small scale.
                </p>*/}

                <Button
                  text={t('footerSections.shop_now')}
                  text_font_size="18"
                  text_font_family="Gilroy-SemiBold"
                  text_font_weight="400"
                  text_line_height="30px"
                  text_text_align="center"
                  text_color="#ffffff"
                  fill_background_color="#ca0d2d"
                  border_border_radius="8px"
                  padding="14px 34px"
                  className="w-auto hover:opacity-90 transition-opacity"
                  layout_width="auto"
                  position="relative"
                  layout_gap="0"
                  margin="0"
                  variant="primary"
                  size="medium"
                  onClick={() => {
                    navigate('/product-listing');
                  }}
                />
              </div>
            </div>

            {/* Hero Image */}
            <div className="w-full lg:w-1/2 flex justify-center lg:justify-end order-1 lg:order-2">
              <img
                src="/images/img_excited_well_dr.png"
                alt="Summer 2024 New Collection - Fashion Model"
                className="w-full max-w-[400px] lg:max-w-[672px] h-auto object-cover"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
